import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import PayrollContent from "components/Payroll/PayrollContent";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { usePageTitle } from "hooks/usePageTitle";

export default function Payroll() {
  usePageTitle("Payroll");
  const entityId = useCurrentEntityId();
  const { uuid: groupId } = useCurrentGroupContext();
  return (
    <DashboardLayout header={<Header title="Payroll" v2 />}>
      <PayrollContent entityId={entityId} groupId={groupId} />
    </DashboardLayout>
  );
}
